import SalutationApi from '../../../api/masterData/mdSalutationApi';
import PlaceApi from '../../../api/masterData/mdPlaceApi';
import TitleApi from '../../../api/masterData/mdTitleApi';
import BankApi from '../../../api/masterData/mdBankApi';
import TaxApi from '../../../api/masterData/mdTaxApi';
import PaymentApi from '../../../api/masterData/mdPaymentApi';
import BusinessApi from '../../../api/masterData/mdBusinessModeApi';
import ProductionSpaceApi from '../../../api/masterData/mdProductionSpaceApi';

export default {
  state: {
    places: [],
    states: [],
    salutations: [],
    countries: [],
    titles: [],
    businessModes: [],
    productionSpaces: []
  },
  mutations: {
    MD_PLACE_SET(state, data) {
      state.places = data;
    },
    MD_SALUTATION_LIST(state, data) {
      state.salutations = data;
    },
    MD_TITLE_LIST(state, data) {
      state.titles = [];
      state.titles.push({id: null, value: "Kein"});
      state.titles = state.titles.concat(data);
    },
    MD_COUNTRIES_SET(state, data) {
      state.countries = data;
    },
    MD_STATES_SET(state, data) {
      state.states = data;
    },
    MD_BUSINESS_MODE_SET(state, data) {
      state.businessModes = data;
    },
    MD_PRODUCTION_SPACE_SET(state, data) {
      state.productionSpaces = data;
    }
  },
  actions: {
    MD_SALUTATION_CREATE(store, data) {
      SalutationApi.create(data).then(() => {
        store.dispatch('NOTIFY_MSG', 'masterData.notification.create');

        if (data.callBack !== undefined) data.callBack();
      }).catch(error => {
        store.dispatch('NOTIFY_ERROR', error);
      })
    },
    MD_SALUTATION_UPDATE(store, data) {
      SalutationApi.update(data.id, data).then(() => {
        store.dispatch('NOTIFY_MSG', 'masterData.notification.create');
        if (data.callBack !== undefined) data.callBack();
      }).catch(error => {
        store.dispatch('NOTIFY_ERROR', error);
      })
    },
    MD_SALUTATION_DELETE(store, data) {
      SalutationApi.delete(data.id).then(() => {
        store.dispatch('NOTIFY_MSG', 'masterData.notification.delete');
        if (data.callBack !== undefined) data.callBack();
      }).catch(error => {
        store.dispatch('NOTIFY_ERROR', error);
      })
    },

    MD_SALUTATION_LIST(store) {
      SalutationApi.list().then(response => {
        store.commit('MD_SALUTATION_LIST', response.data);
      }).catch(error => {
        store.dispatch('NOTIFY_ERROR', error);
      })
    },

    MD_PLACE_FETCH(store) {
      PlaceApi.fetch().then(response => {
        store.commit('MD_PLACE_SET', response.data);
      })
    },
    MD_PLACE_CREATE(store, data) {
      PlaceApi.create(data, data.type).then(() => {
        store.dispatch('NOTIFY_MSG', 'masterData.notification.create');
        store.dispatch('NOTIFY_RESET');
        if (data.callBack !== undefined)
          data.callBack();
      }).catch(error => {
        store.dispatch('NOTIFY_ERROR', error);
      })
    },
    async MD_PLACE_UPDATE(store, data) {
      try {
        await PlaceApi.update(data, data.type);
        store.dispatch('NOTIFY_MSG', 'masterData.notification.create');
        store.dispatch('NOTIFY_RESET');
        return Promise.resolve();
      } catch(error) {
        store.dispatch('NOTIFY_ERROR', error);
      }
    },
    async MD_PLACE_DELETE(store, data) {
      try {
        await PlaceApi.delete(data.id, data.type);
        await store.dispatch('NOTIFY_MSG', 'masterData.notification.delete');
        return Promise.resolve();
      } catch(error) {
        store.dispatch('NOTIFY_ERROR', error);
        return Promise.reject(error);
      }
    },
    MD_TITLE_CREATE(store, data) {
      TitleApi.create(data).then(() => {
        store.dispatch('NOTIFY_MSG', 'masterData.notification.create');

        if (data.callBack !== undefined) data.callBack();
      }).catch(error => {
        store.dispatch('NOTIFY_ERROR', error);
      })
    },
    MD_TITLE_UPDATE(store, data) {
      TitleApi.update(data.id, data).then(() => {
        store.dispatch('NOTIFY_MSG', 'masterData.notification.create');
        if (data.callBack !== undefined) data.callBack();
      }).catch(error => {
        store.dispatch('NOTIFY_ERROR', error);
      })
    },
    MD_TITLE_DELETE(store, data) {
      TitleApi.delete(data.id).then(() => {
        store.dispatch('NOTIFY_MSG', 'masterData.notification.delete');
        if (data.callBack !== undefined) data.callBack();
      }).catch(error => {
        store.dispatch('NOTIFY_ERROR', error);
      })
    },
    MD_TITLE_LIST(store) {
      TitleApi.list().then(response => {
        store.commit('MD_TITLE_LIST', response.data);
      }).catch(error => {
        store.dispatch('NOTIFY_ERROR', error);
      })
    },

    async MD_BANK_FETCH({dispatch}) {
      try {
        const response = await BankApi.fetch();
        return Promise.resolve(response.data);
      } catch(error) {
        dispatch('NOTIFY_ERROR', error);
        return Promise.reject(error);
      }
    },
    MD_BANK_CREATE(store, data) {
      BankApi.create(data).then(() => {
        store.dispatch('NOTIFY_MSG', 'masterData.notification.create');

        if (data.callBack !== undefined) data.callBack();
      }).catch(error => {
        store.dispatch('NOTIFY_ERROR', error);
      })
    },
    MD_BANK_UPDATE(store, data) {
      BankApi.update(data.id, data).then(() => {
        store.dispatch('NOTIFY_MSG', 'masterData.notification.create');
        if (data.callBack !== undefined) data.callBack();
      }).catch(error => {
        store.dispatch('NOTIFY_ERROR', error);
      })
    },
    MD_BANK_DELETE(store, data) {
      BankApi.delete(data.id).then(() => {
        store.dispatch('NOTIFY_MSG', 'masterData.notification.delete');
        if (data.callBack !== undefined) data.callBack();
      }).catch(error => {
        store.dispatch('NOTIFY_ERROR', error);
      })
    },
    MD_TAX_CREATE(store, data) {
      TaxApi.create(data).then(() => {
        store.dispatch('NOTIFY_MSG', 'masterData.notification.create');
        if (data.callBack !== undefined) data.callBack();
      }).catch(error => {
        store.dispatch('NOTIFY_ERROR', error);
      })
    },
    MD_TAX_UPDATE(store, data) {
      TaxApi.update(data.id, data).then(() => {
        store.dispatch('NOTIFY_MSG', 'masterData.notification.create');
        if (data.callBack !== undefined) data.callBack();
      }).catch(error => {
        store.dispatch('NOTIFY_ERROR', error);
      })
    },
    MD_TAX_DELETE(store, data) {
      TaxApi.delete(data.id).then(() => {
        store.dispatch('NOTIFY_MSG', 'masterData.notification.delete');
        if (data.callBack !== undefined) data.callBack();
      }).catch(error => {
        store.dispatch('NOTIFY_ERROR', error);
      })
    },

    async MD_TAX_FETCH({dispatch}) {
      try {
        const response = await TaxApi.fetch();
        return Promise.resolve(response.data);
      } catch (e) {
        dispatch('NOTIFY_ERROR', e);
      }
    },

    async MD_PAYMENT_FETCH({dispatch}) {
      try {
        const response = await PaymentApi.fetch();
        return Promise.resolve(response.data);
      } catch (error) {
        dispatch('NOTIFY_ERROR', error);
        return Promise.reject(error);
      }
    },

    MD_PAYMENT_CREATE(store, data) {
      PaymentApi.create(data).then(() => {
        store.dispatch('NOTIFY_MSG', 'masterData.notification.create');
        if (data.callBack !== undefined) data.callBack();
      }).catch(error => {
        store.dispatch('NOTIFY_ERROR', error);
      })
    },
    MD_PAYMENT_UPDATE(store, data) {
      PaymentApi.update(data.id, data).then(() => {
        store.dispatch('NOTIFY_MSG', 'masterData.notification.create');
        if (data.callBack !== undefined) data.callBack();
      }).catch(error => {
        store.dispatch('NOTIFY_ERROR', error);
      })
    },
    MD_PAYMENT_DELETE(store, data) {
      PaymentApi.delete(data.id).then(() => {
        store.dispatch('NOTIFY_MSG', 'masterData.notification.delete');
        if (data.callBack !== undefined) data.callBack();
      }).catch(error => {
        store.dispatch('NOTIFY_ERROR', error);
      })
    },

    //Business modes
    MD_BUSINESS_MODE_FETCH(store) {
      BusinessApi.fetch().then(response => {
        store.commit('MD_BUSINESS_MODE_SET', response.data);
      }).catch(error => {
        store.dispatch('NOTIFY_ERROR', error);
      })
    },

    MD_BUSINESS_MODE_CREATE(store, data) {
      BusinessApi.create(data).then(() => {
        store.dispatch('NOTIFY_MSG', 'masterData.notification.create');
        if (data.callBack !== undefined) data.callBack();
      }).catch(error => {
        store.dispatch('NOTIFY_ERROR', error);
      })
    },
    MD_BUSINESS_MODE_UPDATE(store, data) {
      BusinessApi.update(data.id, data).then(() => {
        store.dispatch('NOTIFY_MSG', 'masterData.notification.create');
        if (data.callBack !== undefined) data.callBack();
      }).catch(error => {
        store.dispatch('NOTIFY_ERROR', error);
      })
    },
    MD_BUSINESS_MODE_DELETE(store, data) {
      BusinessApi.delete(data.id).then(() => {
        store.dispatch('NOTIFY_MSG', 'masterData.notification.delete');
        if (data.callBack !== undefined) data.callBack();
      }).catch(error => {
        store.dispatch('NOTIFY_ERROR', error);
      })
    },

    //Production spaces
    MD_PRODUCTION_SPACE_FETCH(store) {
      ProductionSpaceApi.fetch().then(response => {
        store.commit('MD_PRODUCTION_SPACE_SET', response.data);
      }).catch(error => {
        store.dispatch('NOTIFY_ERROR', error);
      })
    },
    MD_PRODUCTION_SPACE_CREATE(store, data) {
      ProductionSpaceApi.create(data).then(() => {
        store.dispatch('NOTIFY_MSG', 'masterData.notification.create');
        if (data.callBack !== undefined) data.callBack();
      }).catch(error => {
        store.dispatch('NOTIFY_ERROR', error);
      })
    },
    MD_PRODUCTION_SPACE_UPDATE(store, data) {
      ProductionSpaceApi.update(data.id, data).then(() => {
        store.dispatch('NOTIFY_MSG', 'masterData.notification.create');
        if (data.callBack !== undefined) data.callBack();
      }).catch(error => {
        store.dispatch('NOTIFY_ERROR', error);
      })
    },
    MD_PRODUCTION_SPACE_DELETE(store, data) {
      ProductionSpaceApi.delete(data.id).then(() => {
        store.dispatch('NOTIFY_MSG', 'masterData.notification.delete');
        if (data.callBack !== undefined) data.callBack();
      }).catch(error => {
        store.dispatch('NOTIFY_ERROR', error);
      })
    },
    MD_COUNTRIES_FETCH(store) {
      return new Promise((resolve, reject) => {
        PlaceApi.fetchCountries().then(response => {
          store.commit("MD_COUNTRIES_SET", response.data)
          return resolve(response.data);
        }).catch(error => {
          store.dispatch('NOTIFY_ERROR', error);
          return reject(error);
        })
      });
    },
    MD_STATES_FETCH(store) {
      return new Promise((resolve, reject) => {
        PlaceApi.fetchStates().then(response => {
          store.commit("MD_STATES_SET", response.data)
          return resolve(response.data);
        }).catch(error => {
          store.dispatch('NOTIFY_ERROR', error);
          return reject(error);
        })
      });
    },
    MD_PLACES_FETCH(store, {countryId}) {
      return new Promise((resolve, reject) => {
        PlaceApi.fetchPlaces(countryId).then(response => {
          store.commit("MD_PLACE_SET", response.data)
          resolve();
        }).catch(error => {
          store.dispatch('NOTIFY_ERROR', error);
          reject();
        })
      });
    }
  }
}
